import { useCallback, useEffect, useState } from 'react';
import * as St from './index.styled';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';
import { CustomDialog } from '../../../../../components/dialog/v1/CustomDialog';
import { v4 as uuidv4 } from 'uuid';
import { useApiInfoContextValueHook } from '../../../../../contexts/ApiInfoContextProvider';
import { SellertoolSignatureUtils } from '../../../../../utils/sellertool-signature-utils';
import { CustomBackdropController } from '../../../../../components/backdrop/default/v1';
import axios from 'axios';
import { customToast } from '../../../../../components/toast/custom-react-toastify/v1';
import { CustomRatioImage } from '../../../../../components/image/CustomRatioImage';
import { WegetPalletCanvasLocal } from '../weget-pallet-canvas-local';
import { CustomLabelInput } from '../../../../../components/input/CustomLabelInput';
import qs from 'qs';
import { EditRackLocationAddressModal } from './modals/edit-rack-location-address-modal';
import CustomSmallButton from '../../../../../components/button/CustomSmallButton';
import { BackupRackLocationModal } from './modals/backup-rack-location-modal';
import { ProductOptionPickerModal } from '../../../../../components/product-option-picker-modal';
import { CustomQuantityKeypadModal } from '../../../../../components/custom-quantity-keypad-modal';
import { WegetBulkSelectModal } from '../weget-bulk-select-modal';

const API_HOST = process.env.REACT_APP_MAIN_API_HOST;

// TODO : 파레트 내 상품 수정 시 상품 복사 기능 추가하기
export function WegetViewerPalletFirst({
    pallets,
    loadItems,
    stageUUID,
    currentStage,
    reloadCurrentStage,
    onReqFetch,
    // 준비('pallets') / 확정('confirmed-pallets') 공용. mode는 'PREPARE' | 'CONFIRM'.
    apiResource = 'pallets',
    mode = 'PREPARE',
    counterpartPallets,
    onReqFetchAll,
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    // 준비 → 확정 지정 모달 (확정 파레트 선택)
    const [assignConfirmModalOpen, setAssignConfirmModalOpen] = useState(false);
    // 동일 품목 일괄 선택 모달의 기준 아이템
    const [bulkSelectTarget, setBulkSelectTarget] = useState(null);

    const [selectedPalletUUID, setSelectedPalletUUID] = useState(null);
    const [addPalletModalOpen, setAddPalletModalOpen] = useState(false);
    const [deletePalletModalOpen, setDeletePalletModalOpen] = useState(false);

    const [editRackLocationAddressModalOpen, setEditRackLocationAddressModalOpen] = useState(false);
    const [editChildRackLocationAddressesModalOpen, setEditChildRackLocationAddressesModalOpen] = useState(false);
    const [editTargetPallet, setEditTargetPallet] = useState(null);

    const [selectedLoadItems, setSelectedLoadItems] = useState([]);
    const [editLoadItemsModalOpen, setEditLoadItemsModalOpen] = useState(false);
    const [addLoadItemsModalOpen, setAddLoadItemsModalOpen] = useState(false);

    const [loadedExampleModalOpen, setLoadedExampleModalOpen] = useState(false);
    const [loadedExamplePalletUUID, setLoadedExamplePalletUUID] = useState(null);

    const [changeStatusModalOpen, setChangeStatusModalOpen] = useState(false);

    const [autoMappingLocationModalOpen, setAutoMappingLocationModalOpen] = useState(false);

    const [reflectLocationModalOpen, setReflectLocationModalOpen] = useState(false);
    const [backupRackLocationModalOpen, setBackupRackLocationModalOpen] = useState(false);

    const handleSelectPalletUUID = (uuid) => {
        setSelectedLoadItems([]);
        if (uuid === selectedPalletUUID) {
            setSelectedPalletUUID(null);
            return;
        }

        setSelectedPalletUUID(uuid);
    }

    const handleOpenAddPalletModal = () => {
        setAddPalletModalOpen(true);
    }

    const handleCloseAddPalletModal = () => {
        setAddPalletModalOpen(false);
    }

    const handleOpenDeletePalletModal = () => {
        setDeletePalletModalOpen(true);
    }

    const handleCloseDeletePalletModal = () => {
        setDeletePalletModalOpen(false);
    }

    const handleOpenEditRackLocationAddressModal = (pallet) => {
        setEditTargetPallet(pallet);
        setEditRackLocationAddressModalOpen(true);
    }

    const handleCloseEditRackLocationAddressModal = () => {
        setEditTargetPallet(null);
        setEditRackLocationAddressModalOpen(false);
    }

    const handleOpenEditChildRackLocationAddressesModal = (pallet) => {
        setEditChildRackLocationAddressesModalOpen(true);
        setEditTargetPallet(pallet);
    }

    const handleCloseEditChildRackLocationAddressesModal = () => {
        setEditChildRackLocationAddressesModalOpen(false);
        setEditTargetPallet(null);
    }

    const handleSelectLoadItem = (lItem) => {
        // 준비 탭에서 확정으로 넘어간 아이템은 잠금 → 선택 불가
        if (mode !== 'CONFIRM' && lItem?.confirmedYn === 'y') {
            return;
        }
        setSelectedLoadItems(prev => {
            const existed = prev.find(r => r.uuid === lItem?.uuid);
            if (existed) {
                return prev?.filter(r => r.uuid !== lItem?.uuid);
            } else {
                return prev?.concat(lItem);
            }
        })
    }

    const handleOpenEditLoadItemsModal = () => {
        setEditLoadItemsModalOpen(true);
    }

    const handleCloseEditLoadItemsModal = () => {
        setEditLoadItemsModalOpen(false);
    }

    const handleOpenAddLoadItemsModal = () => {
        setAddLoadItemsModalOpen(true);
    }

    const handleCloseAddLoadItemsModal = () => {
        setAddLoadItemsModalOpen(false);
    }

    const handleOpenChangeStatusModal = (pallet) => {
        setChangeStatusModalOpen(true);
        setEditTargetPallet(pallet);
    }

    const handleCloseChangeStatusModal = () => {
        setChangeStatusModalOpen(false);
        setEditTargetPallet(null);
    }

    const handleReqAddPallet = async (newPallet) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            pallet: newPallet,
        }

        CustomBackdropController().showBackdrop();
        const addResult = await axios.post(`${API_HOST}/${apiResource}/add`, body, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (addResult?.content) {
            handleCloseAddPalletModal();
            onReqFetch();
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleReqDeletePallet = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const targetPallet = pallets.find(r => r.uuid === selectedPalletUUID);
        CustomBackdropController().showBackdrop();
        const deleteResult = await axios.delete(`${API_HOST}/${apiResource}/${targetPallet._id}`, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (deleteResult?.content) {
            handleCloseDeletePalletModal();
            setSelectedPalletUUID(null);
            onReqFetch();
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleReqUpdatePallets = async (newPallets) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            pallets: newPallets
        }
        CustomBackdropController().showBackdrop();
        const result = await axios.put(`${API_HOST}/${apiResource}/bulk-update`, body, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (result?.content) {
            handleCloseEditRackLocationAddressModal();
            handleCloseEditChildRackLocationAddressesModal();
            handleCloseChangeStatusModal();
            onReqFetch();
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleRearrangePallets = async () => {

        const newPallets = pallets?.map((pallet, index) => {
            return {
                ...pallet,
                palletNumber: index + 1
            }
        });

        const newLoadItems = loadItems?.map(lItem => {
            const newPallet = newPallets.find(r => r.uuid === lItem?.palletUUID);
            return {
                ...lItem,
                palletNumber: newPallet?.palletNumber
            }
        });

        handleReqUpdatePallets(newPallets);
        handleReqUpdateLoadItems(newLoadItems);
    };

    const handleReqDeleteLoadItems = async () => {
        if (selectedLoadItems?.length <= 0) {
            customToast.error('삭제할 상품을 선택해 주세요.');
            return;
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const deleteResult = await axios.delete(`${API_HOST}/${apiResource}/load-items/bulk-delete`, {
            data: {
                palletLoadItems: selectedLoadItems
            },
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (deleteResult?.content) {
            setSelectedLoadItems([]);
            onReqFetch();
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleReqUpdateLoadItems = async (newLoadItems) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            palletLoadItems: newLoadItems
        }

        CustomBackdropController().showBackdrop();
        const result = await axios.put(`${API_HOST}/${apiResource}/load-items/bulk-update`, body, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (result?.content) {
            setSelectedLoadItems([]);
            onReqFetch();
            handleCloseEditLoadItemsModal();
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleReqAddLoadItems = async (newLoadItems) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            palletLoadItems: newLoadItems
        }

        CustomBackdropController().showBackdrop();
        const result = await axios.post(`${API_HOST}/${apiResource}/load-items/bulk-add`, body, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (result?.content) {
            onReqFetch();
            handleCloseAddLoadItemsModal();
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleAutoMappingLocation = async (excludedStages) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        // 가용가능한 로케이션 주소를 가져온다.
        const enabledLocationsFetchResult = await axios.get(`${API_HOST}/rack-locations`, {
            headers: headers,
            params: {
                type: 'INVENTORY',
                enabledYn: 'y'
            }
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            });

        let enabledLocations;
        if (enabledLocationsFetchResult?.content) {
            enabledLocations = enabledLocationsFetchResult?.content;

            // 중복되면 안되는 스테이지의 파레트 정보를 가져온다.
            const palletsFetchResult = await axios.get(`${API_HOST}/${apiResource}`, {
                params: {
                    stageUUIDs: excludedStages?.map(r => r?.uuid)
                },
                headers: headers,
                paramsSerializer: params => {
                    return qs.stringify(params, { arrayFormat: 'repeat' });
                }
            })
                .then(res => {
                    return {
                        res: res,
                        content: res.data?.content
                    }
                })
                .catch(err => {
                    customToast.error(err.response);
                })

            let excludedRackLocationAddressesForPalletsSet = new Set();

            if (palletsFetchResult?.content) {
                palletsFetchResult?.content?.pallets?.forEach(pallet => {
                    excludedRackLocationAddressesForPalletsSet.add(pallet?.rackLocationAddress);
                    pallet?.childRackLocationAddresses?.forEach(r => {
                        excludedRackLocationAddressesForPalletsSet.add(r);
                    })
                });
            }

            // 중복되면 안되는 스테이지의 로케이션 주소를 제외한다.
            enabledLocations = enabledLocations?.filter(r => !excludedRackLocationAddressesForPalletsSet.has(r?.address));

            enabledLocations.sort((a, b) => {
                const aSplit = a?.address?.split('-');
                const bSplit = b?.address?.split('-');
                if (`${aSplit[3]}_${aSplit[1]}_${aSplit[2]}_${aSplit[4]}` < `${bSplit[3]}_${bSplit[1]}_${bSplit[2]}_${bSplit[4]}`) return 1;
                if (`${aSplit[3]}_${aSplit[1]}_${aSplit[2]}_${aSplit[4]}` > `${bSplit[3]}_${bSplit[1]}_${bSplit[2]}_${bSplit[4]}`) return -1;
                return 0;
            })
            const newPallets = [...pallets].map(pallet => {
                if (enabledLocations?.length > 0) {
                    const newPallet = {
                        ...pallet,
                        rackLocationAddress: enabledLocations?.pop()?.address
                    }

                    return {
                        ...newPallet
                    }
                }
                return { ...pallet }
            })

            const body = {
                pallets: newPallets
            }

            const updateResult = await axios.put(`${API_HOST}/${apiResource}/bulk-update`, body, {
                headers: headers,
            })
                .then(res => {
                    return {
                        res: res,
                        content: res.data?.content
                    }
                })
                .catch(err => {
                    customToast.error(err.response);
                })

            if (updateResult?.content) {
                onReqFetch();
            }
        }

        handleCloseAutoMappingLocationModal();

        CustomBackdropController().hideBackdrop();
    }

    const handleRemoveChildRackLocationAddress = async (pallet, childRackLocationAddress) => {
        const newPallet = {
            ...pallet,
            childRackLocationAddresses: pallet?.childRackLocationAddresses?.filter(r => r !== childRackLocationAddress)
        };

        handleReqUpdatePallets([{ ...newPallet }]);
    }

    const handleReqReflectLocation = async () => {
        for (const pallet of pallets) {
            if (!pallet.rackLocationAddress) {
                customToast.error('모든 파레트에 로케이션 주소가 있어야 합니다.');
                return;
            }
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const rackLocationsResult = await axios.get(`${API_HOST}/rack-locations`, {
            headers: headers,
            params: {
                type: 'INVENTORY',
                enabledYn: 'y'
            }
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (rackLocationsResult?.content) {
            let rackLocations = rackLocationsResult?.content;

            pallets?.forEach(pallet => {
                pallet?.childRackLocationAddresses?.forEach(childRackLocationAddress => {
                    let temp = rackLocations?.find(rackLocation => rackLocation?.address === childRackLocationAddress);
                    if (temp) {
                        temp.enabledYn = 'n';
                        temp.linkToLocationAddress = pallet?.rackLocationAddress;
                    }
                });

                let temp = rackLocations?.find(r => r.address === pallet?.rackLocationAddress);
                if (temp) {
                    temp.enabledYn = 'n';
                    let targetLoadItems = loadItems?.filter(r => r.palletUUID === pallet?.uuid);
                    temp.items = targetLoadItems?.map(r => {
                        return {
                            uuid: r?.uuid,
                            productName: r?.productName,
                            optionName: r?.optionName,
                            optionCode: r?.optionCode,
                            productQuantity: r?.estimatedProductQuantity,
                            boxQuantity: r?.boxQuantity,
                        }
                    });
                }
            })

            const body = {
                rackLocations: rackLocations,
                stageUUID: stageUUID
            }

            const registerResult = await axios.post(`${API_HOST}/rack-locations/bulk-register`, body, {
                headers: headers,
            })
                .then(res => {
                    return {
                        res: res,
                        content: res.data?.content
                    }
                })
                .catch(err => {
                    customToast.error(err.response);
                })

            if (registerResult?.content) {
                customToast.success('로케이션 등록이 완료되었습니다.');
                reloadCurrentStage();
                handleCloseReflectLocationModal();
            }
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleOpenLoadedExampleModal = (palletUUID) => {
        setLoadedExamplePalletUUID(palletUUID);
        setLoadedExampleModalOpen(true);
    }

    const handleCloseLoadedExampleModal = () => {
        setLoadedExamplePalletUUID(null);
        setLoadedExampleModalOpen(false);
    }

    const handleOpenReflectLocationModal = () => {
        setReflectLocationModalOpen(true);
    }

    const handleCloseReflectLocationModal = () => {
        setReflectLocationModalOpen(false);
    }

    const handleOpenAutoMappingLocationModal = () => {
        setAutoMappingLocationModalOpen(true);
    }

    const handleCloseAutoMappingLocationModal = () => {
        setAutoMappingLocationModalOpen(false);
    }

    const isPrepare = mode !== 'CONFIRM';

    // 동일 품목(상품명 + 옵션명) 풀. 현재 선택된 파레트의 아이템 중 선택 가능한 것만.
    const bulkSelectPool = bulkSelectTarget
        ? (loadItems || []).filter(r =>
            r.palletUUID === selectedPalletUUID &&
            r.productName === bulkSelectTarget.productName &&
            r.optionName === bulkSelectTarget.optionName &&
            // 준비 탭에서 확정된 아이템은 잠금 상태라 선택 대상에서 제외
            !(isPrepare && r.confirmedYn === 'y')
        )
        : [];
    const bulkSelectableItems = bulkSelectPool.filter(r => !selectedLoadItems?.find(s => s.uuid === r.uuid));

    const handleOpenBulkSelectModal = useCallback((loadItem) => {
        setBulkSelectTarget(loadItem);
    }, []);

    const handleCloseBulkSelectModal = () => {
        setBulkSelectTarget(null);
    }

    // 입력한 개수만큼 동일 품목을 추가 선택 (목록에 보이는 순서대로)
    const handleConfirmBulkSelect = (count) => {
        const targets = bulkSelectableItems.slice(0, count);
        if (targets.length <= 0) {
            handleCloseBulkSelectModal();
            return;
        }

        setSelectedLoadItems(prev => prev.concat(targets));
        customToast.success(`동일 품목 ${targets.length}개를 선택했습니다.`);
        handleCloseBulkSelectModal();
    }

    // 준비 모드의 이동 대상 = 확정 파레트 목록
    const buildNextConfirmedPalletNumber = () => {
        if (!counterpartPallets || counterpartPallets.length <= 0) {
            return 1;
        }
        return Math.max(...counterpartPallets.map(p => Number(p.palletNumber) || 0)) + 1;
    }

    // 준비 → 확정 지정. 물리 이동이 아니라 준비 아이템에 확정 필드를 세팅한다.
    // (아이템은 준비에 그대로 남고 잠금 표시된다)
    const handleReqAssignToConfirmed = async (targetPallet, isCreateNew) => {
        if (!selectedLoadItems || selectedLoadItems.length <= 0) {
            return;
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();

        let target = targetPallet;

        // 새 확정 파레트를 만들고 그곳으로 지정
        if (isCreateNew) {
            const newPallet = {
                _id: null,
                uuid: uuidv4(),
                palletNumber: buildNextConfirmedPalletNumber(),
                type: 'HETEROMORPHIC',
                status: 'LOADING',
                rackLocationAddress: '',
                childRackLocationAddresses: [],
                stageUUID: stageUUID,
            };
            const addResult = await axios.post(`${API_HOST}/confirmed-pallets/add`, { pallet: newPallet }, { headers })
                .then(res => ({ content: res.data?.content }))
                .catch(err => { customToast.error(err.response); });
            if (!addResult?.content) {
                CustomBackdropController().hideBackdrop();
                return;
            }
            target = newPallet;
        }

        if (!target) {
            CustomBackdropController().hideBackdrop();
            return;
        }

        const body = {
            palletLoadItems: selectedLoadItems.map(li => ({
                ...li,
                confirmedYn: 'y',
                confirmedPalletUUID: target.uuid,
                confirmedPalletNumber: target.palletNumber,
            })),
        };

        const assignResult = await axios.put(`${API_HOST}/${apiResource}/load-items/bulk-update`, body, { headers })
            .then(res => ({ content: res.data?.content }))
            .catch(err => { customToast.error(err.response); });

        if (assignResult?.content) {
            customToast.success(`${selectedLoadItems.length}개 상품을 확정 파레트 ${target.palletNumber}(으)로 지정했습니다.`);
            setSelectedLoadItems([]);
            setAssignConfirmModalOpen(false);
            (onReqFetchAll || onReqFetch)();
        }
        CustomBackdropController().hideBackdrop();
    }

    // 확정 취소 (준비로 내보내기). 선택 아이템의 확정 필드만 해제 → 준비에 그대로 남는다.
    const handleReqUnconfirm = async () => {
        if (!selectedLoadItems || selectedLoadItems.length <= 0) {
            return;
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            palletLoadItems: selectedLoadItems.map(li => ({ _id: li._id })),
        };

        CustomBackdropController().showBackdrop();
        const result = await axios.post(`${API_HOST}/confirmed-pallets/unconfirm`, body, { headers })
            .then(res => ({ content: res.data?.content }))
            .catch(err => { customToast.error(err.response); });

        if (result?.content) {
            customToast.success(`${selectedLoadItems.length}개 상품을 준비로 내보냈습니다.`);
            setSelectedLoadItems([]);
            (onReqFetchAll || onReqFetch)();
        }
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <St.Body.Container>
                <St.ModeBanner.Container className={mode === 'CONFIRM' ? 'confirm' : 'prepare'}>
                    <span className='dot' />
                    <span className='title'>{mode === 'CONFIRM' ? '파레트 확정' : '파레트 준비'}</span>
                    <span className='desc'>
                        {mode === 'CONFIRM'
                            ? '확정 파레트입니다. 로케이션 반영이 가능하며, 상품을 선택해 준비로 다시 내보낼 수 있습니다.'
                            : '준비 파레트입니다. 상품을 선택해 확정으로 이동할 수 있으며, 확정된 상품은 흐리게 표시되어 선택할 수 없습니다.'}
                    </span>
                </St.ModeBanner.Container>
                <St.Body.Wrapper>
                    <St.Table.Container>
                        <St.Table.EventButtons>
                            <div className='flex gap-1'>
                                <CustomBlockButton
                                    type='button'
                                    onClick={() => handleOpenAddPalletModal()}
                                >
                                    생성
                                </CustomBlockButton>
                                {/* @Deprecated at 2025-06-18 */}
                                {/* <CustomBlockButton
                                    type='button'
                                    onClick={() => handleOpenAutoMappingLocationModal()}
                                >
                                    로케이션 자동매핑
                                </CustomBlockButton> */}
                            </div>
                            {selectedPalletUUID &&
                                <CustomBlockButton
                                    type='button'
                                    className='delete'
                                    onClick={() => handleOpenDeletePalletModal()}
                                >
                                    삭제
                                </CustomBlockButton>
                            }
                        </St.Table.EventButtons>
                        <St.Table.Wrapper>
                            <St.Table.StyledTable>
                                <St.Table.ColumnGroup>
                                    <col width={110} />
                                    <col width={80} />
                                    <col width={80} />
                                    <col width={80} />
                                    <col width={100} />
                                    <col width={100} />
                                    {mode === 'CONFIRM' && <col width={250} />}
                                    <col width={100} />
                                </St.Table.ColumnGroup>
                                <St.Table.TableHeader>
                                    <St.Table.HeaderRow>
                                        <St.Table.HeaderCell>
                                            <div className='flex items-center gap-1 flex-wrap'>
                                                <div>파레트 번호({pallets?.length}개)</div>
                                                <div>
                                                    <CustomBlockButton
                                                        type='button'
                                                        className='rearrangeButton'
                                                        onClick={() => handleRearrangePallets()}
                                                    >
                                                        재배치
                                                    </CustomBlockButton>
                                                </div>
                                            </div>
                                        </St.Table.HeaderCell>
                                        <St.Table.HeaderCell>파레트 성격</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>적재CTNS</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>적재CBM</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>확정 수 / 항목 수</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>상태</St.Table.HeaderCell>
                                        {mode === 'CONFIRM' &&
                                            <St.Table.HeaderCell>로케이션 위치</St.Table.HeaderCell>
                                        }
                                        {/* <St.Table.HeaderCell>병렬 로케이션</St.Table.HeaderCell> */}
                                        <St.Table.HeaderCell>적재 예시</St.Table.HeaderCell>
                                    </St.Table.HeaderRow>
                                </St.Table.TableHeader>
                                <St.Table.TableBody>
                                    {pallets?.map((pallet, index) => {
                                        return <PalletRow
                                            key={pallet?.uuid}
                                            pallet={pallet}
                                            loadItems={loadItems}
                                            selectedPalletUUID={selectedPalletUUID}
                                            onSelectPalletUUID={handleSelectPalletUUID}
                                            onOpenEditRackLocationAddressModal={handleOpenEditRackLocationAddressModal}
                                            onOpenEditChildRackLocationAddressesModal={handleOpenEditChildRackLocationAddressesModal}
                                            onOpenLoadedExampleModal={handleOpenLoadedExampleModal}
                                            onRemoveChildRackLocationAddress={handleRemoveChildRackLocationAddress}
                                            onOpenChangeStatusModal={handleOpenChangeStatusModal}
                                            onOpenBackupRackLocationModal={() => {
                                                setBackupRackLocationModalOpen(true);
                                                setEditTargetPallet(pallet);
                                            }}
                                            mode={mode}
                                        />
                                    })}
                                </St.Table.TableBody>
                            </St.Table.StyledTable>
                        </St.Table.Wrapper>
                    </St.Table.Container>
                    {selectedPalletUUID &&
                        <St.Table.Container>
                            <St.Table.EventButtons>
                                <div className='flex gap-1'>
                                    {isPrepare &&
                                        <CustomBlockButton
                                            type='button'
                                            onClick={() => handleOpenAddLoadItemsModal()}
                                        >
                                            추가
                                        </CustomBlockButton>
                                    }
                                    {selectedLoadItems?.length > 0 &&
                                        <CustomBlockButton
                                            type='button'
                                            onClick={() => handleOpenEditLoadItemsModal()}
                                        >수정</CustomBlockButton>
                                    }
                                    {(isPrepare && selectedLoadItems?.length > 0) &&
                                        <St.Table.MoveConfirmButton
                                            type='button'
                                            onClick={() => setAssignConfirmModalOpen(true)}
                                        >
                                            확정으로 이동 ({selectedLoadItems.length})
                                        </St.Table.MoveConfirmButton>
                                    }
                                    {(!isPrepare && selectedLoadItems?.length > 0) &&
                                        <St.Table.MoveConfirmButton
                                            type='button'
                                            className='toPrepare'
                                            onClick={() => handleReqUnconfirm()}
                                        >
                                            준비로 내보내기 ({selectedLoadItems.length})
                                        </St.Table.MoveConfirmButton>
                                    }
                                </div>
                                {(isPrepare && selectedLoadItems?.length > 0) &&
                                    <CustomBlockButton
                                        type='button'
                                        className='delete'
                                        onClick={() => handleReqDeleteLoadItems()}
                                    >
                                        삭제
                                    </CustomBlockButton>
                                }
                            </St.Table.EventButtons>
                            <St.Table.Wrapper>
                                <St.Table.StyledTable>
                                    <St.Table.ColumnGroup>
                                        <col width={150} />
                                        <col width={70} />
                                        <col width={70} />
                                        <col width={110} />
                                    </St.Table.ColumnGroup>
                                    <St.Table.TableHeader>
                                        <St.Table.HeaderRow>
                                            <St.Table.HeaderCell>상품명 / 옵션명</St.Table.HeaderCell>
                                            <St.Table.HeaderCell>박스 수량</St.Table.HeaderCell>
                                            <St.Table.HeaderCell>박스CBM</St.Table.HeaderCell>
                                            <St.Table.HeaderCell>너비 / 깊이 / 높이(mm)</St.Table.HeaderCell>
                                        </St.Table.HeaderRow>
                                    </St.Table.TableHeader>
                                    <St.Table.TableBody>
                                        {loadItems?.filter(r => r.palletUUID === selectedPalletUUID)?.map(loadItem => {
                                            const isSelected = selectedLoadItems?.find(r => r.uuid === loadItem?.uuid);
                                            // 준비 탭에서 확정으로 넘어간 아이템은 잠금 표시
                                            const isLocked = isPrepare && loadItem?.confirmedYn === 'y';

                                            return (
                                                <LoadItemRow
                                                    key={loadItem?.uuid}
                                                    loadItem={loadItem}
                                                    isSelected={isSelected}
                                                    isLocked={isLocked}
                                                    onSelectLoadItem={handleSelectLoadItem}
                                                    onOpenBulkSelectModal={handleOpenBulkSelectModal}
                                                />
                                            );
                                        })}
                                    </St.Table.TableBody>
                                </St.Table.StyledTable>
                            </St.Table.Wrapper>
                        </St.Table.Container>
                    }
                </St.Body.Wrapper>
                {(loadedExampleModalOpen && loadedExamplePalletUUID) &&
                    <WegetPalletCanvasLocal
                        open={loadedExampleModalOpen}
                        onClose={handleCloseLoadedExampleModal}
                        loadItems={loadItems}
                        palletUUID={loadedExamplePalletUUID}
                    />
                }
                {/* @Deprecated at 2025-06-18 */}
                {/* <St.Body.SaveButtonWrapper>
                    {currentStage?.status === 'COMMITTED' ?
                        <CustomBlockButton
                            type='button'
                            disabled
                        >
                            이미 반영됨
                        </CustomBlockButton>
                        :
                        <CustomBlockButton
                            type='button'
                            onClick={() => handleOpenReflectLocationModal()}
                        >
                            로케이션 반영
                        </CustomBlockButton>
                    }
                </St.Body.SaveButtonWrapper> */}
            </St.Body.Container>

            {addPalletModalOpen &&
                <AddPalletModal
                    open={addPalletModalOpen}
                    onClose={handleCloseAddPalletModal}
                    addPalletNumber={(!pallets || pallets?.length <= 0) ? 1 : pallets?.length + 1}
                    onReqAddPallet={handleReqAddPallet}
                    stageUUID={stageUUID}
                />
            }

            {deletePalletModalOpen &&
                <DeletePalletModal
                    open={deletePalletModalOpen}
                    onClose={handleCloseDeletePalletModal}
                    targetPalletNumber={pallets?.find(r => r.uuid === selectedPalletUUID)?.palletNumber}
                    onReqDeletePallet={handleReqDeletePallet}
                />
            }

            {editLoadItemsModalOpen &&
                <EditLoadItemsModal
                    open={editLoadItemsModalOpen}
                    onClose={handleCloseEditLoadItemsModal}
                    selectedLoadItems={selectedLoadItems}
                    pallets={pallets}
                    onReqUpdateLoadItems={handleReqUpdateLoadItems}
                />
            }

            {addLoadItemsModalOpen &&
                <AddLoadItemsModal
                    open={addLoadItemsModalOpen}
                    onClose={handleCloseAddLoadItemsModal}
                    selectedPallet={pallets?.find(r => r.uuid === selectedPalletUUID)}
                    onReqAddLoadItems={handleReqAddLoadItems}
                    stageUUID={stageUUID}
                />
            }

            {editRackLocationAddressModalOpen &&
                <EditRackLocationAddressModal
                    open={editRackLocationAddressModalOpen}
                    onClose={handleCloseEditRackLocationAddressModal}
                    editTargetPallet={editTargetPallet}
                    pallets={pallets}
                    loadItems={loadItems}
                    onReqFetch={onReqFetch}
                    apiResource={apiResource}
                />
            }

            {backupRackLocationModalOpen &&
                <BackupRackLocationModal
                    open={backupRackLocationModalOpen}
                    onClose={() => {
                        setBackupRackLocationModalOpen(false)
                        setEditTargetPallet(null);
                    }}
                    editTargetPallet={editTargetPallet}
                    pallets={pallets}
                    loadItems={loadItems}
                    onReqFetch={onReqFetch}
                    apiResource={apiResource}
                />
            }

            {editChildRackLocationAddressesModalOpen &&
                <EditChildRackLocationAddressesModal
                    open={editChildRackLocationAddressesModalOpen}
                    onClose={handleCloseEditChildRackLocationAddressesModal}
                    editTargetPallet={editTargetPallet}
                    pallets={pallets}
                    onReqUpdatePallets={handleReqUpdatePallets}
                />
            }

            {reflectLocationModalOpen &&
                <ReflectLocationModal
                    open={reflectLocationModalOpen}
                    onClose={handleCloseReflectLocationModal}
                    onReqRegisterLocation={handleReqReflectLocation}
                />
            }

            {(changeStatusModalOpen && editTargetPallet) &&
                <ChangeStatusModal
                    open={changeStatusModalOpen}
                    onClose={handleCloseChangeStatusModal}
                    editTargetPallet={editTargetPallet}
                    onReqUpdatePallets={handleReqUpdatePallets}
                />
            }

            {autoMappingLocationModalOpen &&
                <AutoMappingLocationModal
                    open={autoMappingLocationModalOpen}
                    onClose={handleCloseAutoMappingLocationModal}
                    currentStageUUID={stageUUID}
                    onAutoMappingLocation={handleAutoMappingLocation}
                />
            }

            {bulkSelectTarget &&
                <WegetBulkSelectModal
                    open={!!bulkSelectTarget}
                    onClose={handleCloseBulkSelectModal}
                    productName={bulkSelectTarget?.productName}
                    optionName={bulkSelectTarget?.optionName}
                    totalCount={bulkSelectPool.length}
                    selectedCount={bulkSelectPool.length - bulkSelectableItems.length}
                    selectableCount={bulkSelectableItems.length}
                    onConfirm={handleConfirmBulkSelect}
                />
            }

            {assignConfirmModalOpen &&
                <AssignToConfirmModal
                    open={assignConfirmModalOpen}
                    onClose={() => setAssignConfirmModalOpen(false)}
                    confirmedPallets={counterpartPallets}
                    selectedCount={selectedLoadItems?.length}
                    onReqAssign={handleReqAssignToConfirmed}
                />
            }
        </>
    );
}

const PalletRow = ({
    pallet,
    loadItems,
    selectedPalletUUID,
    onSelectPalletUUID,
    onOpenEditRackLocationAddressModal,
    onOpenEditChildRackLocationAddressesModal,
    onOpenLoadedExampleModal,
    onRemoveChildRackLocationAddress,
    onOpenChangeStatusModal,
    onOpenBackupRackLocationModal,
    mode = 'PREPARE'
}) => {
    let ctns = 0;
    let cbm = 0;
    let targetLoadItems = [];
    let targetConfirmedLoadItems = [];

    loadItems?.forEach(r => {
        if (r.palletUUID === pallet.uuid) {
            ctns += r.boxQuantity;
            cbm += r.boxQuantity * r.boxCBM;
            targetLoadItems.push(r);
            // 확정 여부는 단일 원본 모델의 confirmedYn 기준 (구 loadedYn은 더 이상 세팅되지 않음)
            if (r.confirmedYn === 'y') {
                targetConfirmedLoadItems.push(r);
            }
        }
    });
    cbm = Math.round(cbm * 100) / 100;

    return (
        <St.Table.TableRow
            key={pallet?.uuid}
            onClick={() => onSelectPalletUUID(pallet?.uuid)}
            className={`${pallet?.uuid === selectedPalletUUID ? 'selected' : ''}`}
        >
            <St.Table.TableCell>{pallet?.palletNumber}</St.Table.TableCell>
            <St.Table.TableCell>
                <St.Table.TypeBadge type={pallet?.type}>
                    {pallet?.type === 'EXTRA'
                        ? '복합제품'
                        : pallet?.type === 'HETEROMORPHIC'
                            ? '이형제품'
                            : '일반제품'}
                </St.Table.TypeBadge>
            </St.Table.TableCell>
            <St.Table.TableCell>{ctns}</St.Table.TableCell>
            <St.Table.TableCell>{cbm}</St.Table.TableCell>
            <St.Table.TableCell>
                <div className='loadedCountField'>
                    <span style={targetConfirmedLoadItems?.length === targetLoadItems?.length ? {} : { color: 'var(--redColor1)' }}>{targetConfirmedLoadItems?.length}</span>
                    <span>/</span>
                    <span>{targetLoadItems?.length}</span>
                </div>
            </St.Table.TableCell>
            <St.Table.TableCell>
                {(!pallet?.status || pallet?.status === 'LOADING') &&
                    <CustomBlockButton
                        type='button'
                        className='handlerButton status loading'
                        onClick={(e) => { e.stopPropagation(); onOpenChangeStatusModal(pallet); }}
                    >
                        적재중
                    </CustomBlockButton>
                }
                {pallet?.status === 'PREPARED' &&
                    <CustomBlockButton
                        type='button'
                        className='handlerButton status prepared'
                        onClick={(e) => { e.stopPropagation(); onOpenChangeStatusModal(pallet); }}
                    >
                        적재완료
                    </CustomBlockButton>
                }
                {pallet?.status === 'DONE' &&
                    <CustomBlockButton
                        type='button'
                        className='handlerButton status done'
                        onClick={(e) => { e.stopPropagation(); onOpenChangeStatusModal(pallet); }}
                    >
                        입고완료
                    </CustomBlockButton>
                }

                {pallet?.status === 'HOLDING' &&
                    <CustomBlockButton
                        type='button'
                        className='handlerButton status holding'
                        onClick={(e) => { e.stopPropagation(); onOpenChangeStatusModal(pallet); }}
                    >
                        보류
                    </CustomBlockButton>
                }
            </St.Table.TableCell>
            {mode === 'CONFIRM' &&
                <St.Table.TableCell>
                    {pallet.rackLocationAddress ?
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
                            <div style={{ fontWeight: '600' }}>
                                <div>로케이션: {pallet.rackLocationAddress}</div>
                                <div>병렬 로케이션: {(pallet.childRackLocationAddresses && pallet.childRackLocationAddresses?.length > 0) ? pallet.childRackLocationAddresses[0] : '-'}</div>
                            </div>
                            <div>
                                <CustomSmallButton
                                    type='button'
                                    onClick={(e) => { e.stopPropagation(); onOpenBackupRackLocationModal(); }}
                                >
                                    되돌리기
                                </CustomSmallButton>
                            </div>
                        </div>
                        :
                        <CustomBlockButton
                            type='button'
                            className='handlerButton'
                            onClick={(e) => { e.stopPropagation(); onOpenEditRackLocationAddressModal(pallet); }}
                        >로케이션 반영</CustomBlockButton>
                    }
                </St.Table.TableCell>
            }
            {/* <St.Table.TableCell>
                <div className='childRackLocations'>
                    <CustomBlockButton
                        type='button'
                        className='handlerButton'
                        onClick={(e) => { e.stopPropagation(); onOpenEditChildRackLocationAddressesModal(pallet); }}
                    >
                        추가
                    </CustomBlockButton>
                    {pallet?.childRackLocationAddresses?.map(rackLocationAddress => {
                        return (
                            <span className='childRackLocationSpan' key={rackLocationAddress} onClick={(e) => { e.stopPropagation(); onRemoveChildRackLocationAddress(pallet, rackLocationAddress) }}>
                                {rackLocationAddress}
                                <div className='removeIcon'>
                                    <CustomRatioImage.Figure>
                                        <CustomRatioImage.Image src='/assets/icons/close_default_red1.svg' />
                                    </CustomRatioImage.Figure>
                                </div>
                            </span>
                        );
                    })}
                </div>
            </St.Table.TableCell> */}
            <St.Table.TableCell>
                <CustomBlockButton
                    type='button'
                    className='handlerButton'
                    onClick={(e) => { e.stopPropagation(); onOpenLoadedExampleModal(pallet?.uuid); }}
                >보기</CustomBlockButton>
            </St.Table.TableCell>
        </St.Table.TableRow>
    );
};

const LoadItemRow = ({
    loadItem,
    isSelected,
    isLocked,
    onSelectLoadItem,
    onOpenBulkSelectModal
}) => {
    return (
        <St.Table.TableRow
            key={loadItem?.uuid}
            className={`${isSelected ? 'selected' : ''} ${isLocked ? 'locked' : ''}`}
            onClick={() => { if (!isLocked) onSelectLoadItem(loadItem); }}
        >
            <St.Table.TableCell>
                <div className='flex items-center gap-1 flex-wrap'>
                    <div>
                        <div>{loadItem?.productName}</div>
                        <div>{loadItem?.optionName}</div>
                        {!isLocked &&
                            <St.Table.BulkSelectButton
                                type='button'
                                onClick={(e) => { e.stopPropagation(); onOpenBulkSelectModal(loadItem); }}
                            >
                                동일 품목 선택
                            </St.Table.BulkSelectButton>
                        }
                    </div>
                    {isLocked &&
                        <St.Table.ConfirmedBadge>확정 {loadItem?.confirmedPalletNumber}</St.Table.ConfirmedBadge>
                    }
                </div>
            </St.Table.TableCell>
            <St.Table.TableCell>
                {loadItem?.boxQuantity}
            </St.Table.TableCell>
            <St.Table.TableCell>{Math.round(loadItem?.boxCBM * 100000) / 100000}</St.Table.TableCell>
            <St.Table.TableCell>{loadItem?.boxWidth} * {loadItem?.boxDepth} * {loadItem?.boxHeight}</St.Table.TableCell>
        </St.Table.TableRow>
    );
};

// 준비 → 확정 지정 대상(확정 파레트) 선택 모달
function AssignToConfirmModal({
    open,
    onClose,
    confirmedPallets,
    selectedCount,
    onReqAssign
}) {
    const sortedPallets = (confirmedPallets || []).slice()
        .sort((a, b) => (Number(a.palletNumber) || 0) - (Number(b.palletNumber) || 0));

    return (
        <CustomDialog open={open} onClose={() => onClose()}>
            <St.MoveToConfirmModal.Header>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>선택 {selectedCount}개 확정으로 이동</CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={() => onClose()} />
                </CustomDialog.Header>
            </St.MoveToConfirmModal.Header>
            <St.MoveToConfirmModal.Body>
                <div className='guide'>지정한 상품은 준비 탭에 흐리게 남고, 확정 탭에 나타납니다.</div>
                <div className='gridWrapper'>
                    <button
                        type='button'
                        className='item newItem'
                        onClick={() => onReqAssign(null, true)}
                    >
                        <span className='plus'>＋</span>
                        <span>새 확정 파레트로 이동</span>
                    </button>
                    {sortedPallets.map(pallet => {
                        return (
                            <button
                                key={pallet.uuid}
                                type='button'
                                className='item'
                                onClick={() => onReqAssign(pallet, false)}
                            >
                                <span className='no'>{pallet.palletNumber}</span>
                                <span className='label'>확정 파레트 {pallet.palletNumber}</span>
                            </button>
                        );
                    })}
                </div>
            </St.MoveToConfirmModal.Body>
        </CustomDialog>
    );
}

function AddPalletModal({
    open,
    onClose,
    addPalletNumber,
    onReqAddPallet,
    stageUUID
}) {
    const [addPalletForm, setAddPalletForm] = useState({
        _id: null,
        uuid: uuidv4(),
        palletNumber: addPalletNumber,
        type: 'HETEROMORPHIC',
        status: 'LOADING',
        rackLocationAddress: '',
        childRackLocationAddresses: [],
        stageUUID: stageUUID
    });

    return (
        <>
            <CustomDialog open={open} onClose={() => onClose()}>
                <St.AddPalletModal.Header>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>파레트 생성</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </St.AddPalletModal.Header>
                <St.AddPalletModal.Body>
                    <div className='notice'>파레트 번호 {addPalletForm?.palletNumber} 를 생성합니다.</div>
                    <div className='buttons'>
                        <CustomBlockButton
                            type='button'
                            onClick={() => onClose()}
                        >
                            취소
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className='add'
                            onClick={() => onReqAddPallet(addPalletForm)}
                        >
                            생성
                        </CustomBlockButton>
                    </div>
                </St.AddPalletModal.Body>
            </CustomDialog>
        </>
    );
}

function DeletePalletModal({
    open,
    onClose,
    targetPalletNumber,
    onReqDeletePallet
}) {


    return (
        <>
            <CustomDialog open={open} onClose={() => onClose()}>
                <St.AddPalletModal.Header>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>파레트 생성</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </St.AddPalletModal.Header>
                <St.AddPalletModal.Body>
                    <div className='notice'>파레트 번호 {targetPalletNumber} 을 삭제합니다.</div>
                    <div className='notice'>하위 제품들도 모두 삭제 됩니다.</div>
                    <div className='buttons'>
                        <CustomBlockButton
                            type='button'
                            onClick={() => onClose()}
                        >
                            취소
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className='delete'
                            onClick={() => onReqDeletePallet()}
                        >
                            삭제
                        </CustomBlockButton>
                    </div>
                </St.AddPalletModal.Body>
            </CustomDialog>
        </>
    );
}

function EditLoadItemsModal({
    open,
    onClose,
    selectedLoadItems,
    pallets,
    onReqUpdateLoadItems
}) {
    const [editLoadItems, setEditLoadItems] = useState([...selectedLoadItems]);
    const [palletChangeModalOpen, setPalletChangeModalOpen] = useState(false);
    const [palletChangeAllModalOpen, setPalletChangeAllModalOpen] = useState(false);

    const [targetLoadItem, setTargetLoadItem] = useState(null);

    // 빠른채움: 상품 선택 모달로 채워 넣을 대상 행(loadItem)
    const [quickFillTargetLoadItem, setQuickFillTargetLoadItem] = useState(null);

    const handleOpenQuickFill = (lItem) => {
        setQuickFillTargetLoadItem(lItem);
    }

    const handleCloseQuickFill = () => {
        setQuickFillTargetLoadItem(null);
    }

    const handleSelectProductOption = (productOption) => {
        if (!quickFillTargetLoadItem) {
            return;
        }
        setEditLoadItems(prev => {
            return prev?.map(r => {
                if (r.uuid === quickFillTargetLoadItem?.uuid) {
                    return {
                        ...r,
                        productName: productOption?.productName ?? r.productName,
                        optionName: productOption?.productOptionName ?? r.optionName,
                        optionCode: productOption?.productOptionCode ?? r.optionCode,
                    }
                }
                return { ...r }
            })
        })
    }

    // 수량 키패드: { uuid, field, label, value } 또는 null
    const [quantityKeypad, setQuantityKeypad] = useState(null);

    const handleOpenQuantityKeypad = (uuid, field, label, value) => {
        setQuantityKeypad({ uuid, field, label, value: Number(value) || 0 });
    }

    const handleCloseQuantityKeypad = () => {
        setQuantityKeypad(null);
    }

    const handleConfirmQuantity = (newValue) => {
        if (!quantityKeypad) {
            return;
        }
        const { uuid, field } = quantityKeypad;
        setEditLoadItems(prev => {
            return prev?.map(r => {
                if (r.uuid === uuid) {
                    return { ...r, [field]: newValue }
                }
                return { ...r }
            })
        })
    }

    const handleOpenPalletChangeModal = (lItem) => {
        setPalletChangeModalOpen(true);
        setTargetLoadItem(lItem)
    }

    const handleClosePalletChangeModal = () => {
        setPalletChangeModalOpen(false);
        setTargetLoadItem(null);
    }

    const handleOpenPalletChangeAllModal = () => {
        setPalletChangeAllModalOpen(true);
    }

    const handleClosePalletChangeAllModal = () => {
        setPalletChangeAllModalOpen(false);
    }

    const handleChangePalletInfo = (palletUUID, palletNumber) => {
        setEditLoadItems(prev => {
            return prev?.map(r => {
                if (r?.uuid === targetLoadItem?.uuid) {
                    return {
                        ...r,
                        palletUUID: palletUUID,
                        palletNumber: palletNumber
                    }
                }
                return { ...r }
            })
        })
        handleClosePalletChangeModal(false);
        setTargetLoadItem(null);
    }

    const handleChangeAllPalletInfo = (palletUUID, palletNumber) => {
        setEditLoadItems(prev => {
            return prev?.map(r => {
                return {
                    ...r,
                    palletUUID: palletUUID,
                    palletNumber: palletNumber
                }
            })
        })
        handleClosePalletChangeAllModal(false);
    }

    const handleChangeTextValue = (e, lItem) => {
        const name = e.target.name;
        const value = e.target.value;

        setEditLoadItems(prev => {
            return prev?.map(r => {
                if (r.uuid === lItem?.uuid) {
                    return { ...r, [name]: value }
                }
                return { ...r }
            })
        })
    }

    const handleChangeNumberValue = (e, lItem) => {
        const name = e.target.name;
        const value = e.target.value;

        setEditLoadItems(prev => {
            return prev?.map(r => {
                if (r.uuid === lItem?.uuid) {
                    if (!value) {
                        return { ...r, [name]: '' }
                    }

                    return { ...r, [name]: Number(value) }
                }
                return { ...r }
            })
        })
    }

    const handleSubmit = async () => {
        const form = editLoadItems?.map(r => {
            const targetPallet = pallets?.find(pallet => pallet.uuid === r.palletUUID);

            return {
                ...r,
                productName: r.productName?.trim(),
                optionName: r.optionName?.trim(),
                optionCode: r.optionCode?.trim(),
                boxQuantity: Number(r.boxQuantity),
                estimatedProductQuantity: Math.round(Number(r.estimatedProductQuantity) * 100) / 100,
                waybillNumber: r.waybillNumber,
                boxWidth: r.boxWidth,
                boxDepth: r.boxDepth,
                boxHeight: r.boxHeight,
                boxCBM: Math.round(((r.boxWidth * r.boxDepth * r.boxHeight) / 1000000000) * 1000000) / 1000000,
                palletUUID: targetPallet?.uuid,
                palletNumber: targetPallet?.palletNumber
            }
        })

        onReqUpdateLoadItems(form)
    }

    return (
        <>
            <CustomDialog open={open} maxWidth='lg'>
                <St.EditLoadItemsModal.Header>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>상품 수정</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </St.EditLoadItemsModal.Header>
                <St.EditLoadItemsModal.Body>
                    <St.Table.Container>
                        <St.Table.Wrapper>
                            <St.Table.StyledTable>
                                <St.Table.ColumnGroup>
                                    <col width={80} />
                                    <col width={90} />
                                    <col width={200} />
                                    <col width={200} />
                                    <col width={160} />
                                    <col width={80} />
                                    <col width={80} />
                                    <col width={170} />
                                    <col width={90} />
                                    <col width={90} />
                                    <col width={90} />
                                </St.Table.ColumnGroup>
                                <St.Table.TableHeader>
                                    <St.Table.HeaderRow>
                                        <St.Table.HeaderCell>파레트번호</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>빠른채움</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>상품명</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>옵션명</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>옵션코드</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>박스수량</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>추정상품수량</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>운송장번호</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>박스너비(mm)</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>박스깊이(mm)</St.Table.HeaderCell>
                                        <St.Table.HeaderCell>박스높이(mm)</St.Table.HeaderCell>
                                    </St.Table.HeaderRow>
                                </St.Table.TableHeader>
                                <St.Table.TableBody>
                                    {editLoadItems?.map(loadItem => {
                                        return (
                                            <St.Table.TableRow
                                                key={loadItem?.uuid}
                                            >
                                                <St.Table.TableCell>
                                                    <CustomBlockButton
                                                        type='button'
                                                        onClick={() => handleOpenPalletChangeModal(loadItem)}
                                                        className='cellButton'
                                                    >
                                                        {loadItem?.palletNumber || ''}
                                                    </CustomBlockButton>
                                                </St.Table.TableCell>
                                                <St.Table.TableCell>
                                                    <CustomBlockButton
                                                        type='button'
                                                        className='quickFillButton'
                                                        onClick={() => handleOpenQuickFill(loadItem)}
                                                    >
                                                        빠른채움
                                                    </CustomBlockButton>
                                                </St.Table.TableCell>
                                                <St.Table.TableCell>
                                                    <input
                                                        type='text'
                                                        className='cellInput'
                                                        name='productName'
                                                        value={loadItem?.productName || ''}
                                                        onChange={(e) => handleChangeTextValue(e, loadItem)}
                                                    ></input>

                                                </St.Table.TableCell>
                                                <St.Table.TableCell>
                                                    <input
                                                        type='text'
                                                        className='cellInput'
                                                        name='optionName'
                                                        value={loadItem?.optionName || ''}
                                                        onChange={(e) => handleChangeTextValue(e, loadItem)}
                                                    ></input>

                                                </St.Table.TableCell>
                                                <St.Table.TableCell>
                                                    <input
                                                        type='text'
                                                        className='cellInput'
                                                        name='optionCode'
                                                        value={loadItem?.optionCode || ''}
                                                        onChange={(e) => handleChangeTextValue(e, loadItem)}
                                                    ></input>

                                                </St.Table.TableCell>
                                                <St.Table.TableCell>
                                                    <CustomBlockButton
                                                        type='button'
                                                        className='quantityCell'
                                                        onClick={() => handleOpenQuantityKeypad(loadItem?.uuid, 'boxQuantity', '박스수량', loadItem?.boxQuantity)}
                                                    >
                                                        {loadItem?.boxQuantity ?? 0}
                                                    </CustomBlockButton>
                                                </St.Table.TableCell>
                                                <St.Table.TableCell>
                                                    <CustomBlockButton
                                                        type='button'
                                                        className='quantityCell'
                                                        onClick={() => handleOpenQuantityKeypad(loadItem?.uuid, 'estimatedProductQuantity', '추정상품수량', loadItem?.estimatedProductQuantity)}
                                                    >
                                                        {loadItem?.estimatedProductQuantity ?? 0}
                                                    </CustomBlockButton>
                                                </St.Table.TableCell>
                                                <St.Table.TableCell>
                                                    <textarea
                                                        type='text'
                                                        className='cellTextarea'
                                                        name='waybillNumber'
                                                        value={loadItem?.waybillNumber || ''}
                                                        onChange={(e) => handleChangeTextValue(e, loadItem)}
                                                    ></textarea>

                                                </St.Table.TableCell>
                                                <St.Table.TableCell>
                                                    <input
                                                        type='number'
                                                        className='cellInput'
                                                        name='boxWidth'
                                                        value={loadItem?.boxWidth ?? ''}
                                                        onChange={(e) => handleChangeNumberValue(e, loadItem)}
                                                    ></input>

                                                </St.Table.TableCell>
                                                <St.Table.TableCell>
                                                    <input
                                                        type='number'
                                                        className='cellInput'
                                                        name='boxDepth'
                                                        value={loadItem?.boxDepth ?? ''}
                                                        onChange={(e) => handleChangeNumberValue(e, loadItem)}
                                                    ></input>

                                                </St.Table.TableCell>
                                                <St.Table.TableCell>
                                                    <input
                                                        type='number'
                                                        className='cellInput'
                                                        name='boxHeight'
                                                        value={loadItem?.boxHeight ?? ''}
                                                        onChange={(e) => handleChangeNumberValue(e, loadItem)}
                                                    ></input>

                                                </St.Table.TableCell>
                                            </St.Table.TableRow>
                                        );
                                    })}
                                </St.Table.TableBody>
                            </St.Table.StyledTable>
                        </St.Table.Wrapper>
                    </St.Table.Container>
                    <div className='bottomButtons'>
                        <CustomBlockButton
                            type='button'
                            onClick={() => handleOpenPalletChangeAllModal()}
                        >
                            파레트번호 일괄 변경
                        </CustomBlockButton>
                    </div>
                    <div className='buttons'>
                        <CustomBlockButton
                            type='button'
                            onClick={() => onClose()}
                        >
                            취소
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className='confirm'
                            onClick={() => handleSubmit()}
                        >
                            수정
                        </CustomBlockButton>
                    </div>
                </St.EditLoadItemsModal.Body>

                <ProductOptionPickerModal
                    open={!!quickFillTargetLoadItem}
                    onClose={handleCloseQuickFill}
                    onSelect={handleSelectProductOption}
                />

                {/* 키패드는 수정 다이얼로그의 포커스 트랩 안에 있어야 직접 입력이 가능하므로 다이얼로그 내부에 렌더 */}
                <CustomQuantityKeypadModal
                    open={!!quantityKeypad}
                    label={quantityKeypad?.label}
                    initialValue={quantityKeypad?.value}
                    onClose={handleCloseQuantityKeypad}
                    onConfirm={handleConfirmQuantity}
                />
            </CustomDialog>

            {palletChangeModalOpen &&
                <CustomDialog open={palletChangeModalOpen} onClose={() => handleClosePalletChangeModal()}>
                    <St.EditLoadItemsModal.PalletChangeModalContainer>
                        <div className='header'>
                            <CustomDialog.Header>
                                <CustomDialog.Header.Fake />
                                <CustomDialog.Header.Title>파레트번호 변경</CustomDialog.Header.Title>
                                <CustomDialog.Header.Close onClick={() => handleClosePalletChangeModal()} />
                            </CustomDialog.Header>
                        </div>
                        <div className='body'>
                            {pallets?.map(pallet => {
                                return (
                                    <div
                                        key={pallet?.uuid}
                                        className='item'
                                        onClick={() => handleChangePalletInfo(pallet?.uuid, pallet?.palletNumber)}
                                    >
                                        {pallet?.palletNumber}
                                    </div>
                                );
                            })}
                        </div>
                    </St.EditLoadItemsModal.PalletChangeModalContainer>
                </CustomDialog>
            }

            {palletChangeAllModalOpen &&
                <CustomDialog open={palletChangeAllModalOpen} onClose={() => handleClosePalletChangeAllModal()}>
                    <St.EditLoadItemsModal.PalletChangeModalContainer>
                        <div className='header'>
                            <CustomDialog.Header>
                                <CustomDialog.Header.Fake />
                                <CustomDialog.Header.Title>파레트번호 일괄 변경</CustomDialog.Header.Title>
                                <CustomDialog.Header.Close onClick={() => handleClosePalletChangeAllModal()} />
                            </CustomDialog.Header>
                        </div>
                        <div className='body'>
                            {pallets?.map(pallet => {
                                return (
                                    <div
                                        key={pallet?.uuid}
                                        className='item'
                                        onClick={() => handleChangeAllPalletInfo(pallet?.uuid, pallet?.palletNumber)}
                                    >
                                        {pallet?.palletNumber}
                                    </div>
                                );
                            })}
                        </div>
                    </St.EditLoadItemsModal.PalletChangeModalContainer>
                </CustomDialog>
            }
        </>
    );
}

function AddLoadItemsModal({
    open,
    onClose,
    selectedPallet,
    onReqAddLoadItems,
    stageUUID
}) {
    const [addLoadItems, setAddLoadItems] = useState([]);
    // 빠른채움: 상품 선택 모달로 채워 넣을 대상 행(loadItem)
    const [quickFillTargetLoadItem, setQuickFillTargetLoadItem] = useState(null);
    // 수량 키패드: { uuid, field, label, value } 또는 null
    const [quantityKeypad, setQuantityKeypad] = useState(null);

    const handleOpenQuantityKeypad = (uuid, field, label, value) => {
        setQuantityKeypad({ uuid, field, label, value: Number(value) || 0 });
    }

    const handleCloseQuantityKeypad = () => {
        setQuantityKeypad(null);
    }

    const handleConfirmQuantity = (newValue) => {
        if (!quantityKeypad) {
            return;
        }
        const { uuid, field } = quantityKeypad;
        setAddLoadItems(prev => {
            return prev?.map(r => {
                if (r.uuid === uuid) {
                    return { ...r, [field]: newValue }
                }
                return { ...r }
            })
        })
    }

    const handleOpenQuickFill = (lItem) => {
        setQuickFillTargetLoadItem(lItem);
    }

    const handleCloseQuickFill = () => {
        setQuickFillTargetLoadItem(null);
    }

    const handleSelectProductOption = (productOption) => {
        if (!quickFillTargetLoadItem) {
            return;
        }

        setAddLoadItems(prev => {
            return prev?.map(r => {
                if (r.uuid === quickFillTargetLoadItem?.uuid) {
                    return {
                        ...r,
                        productName: productOption?.productName ?? r.productName,
                        optionName: productOption?.productOptionName ?? r.optionName,
                        optionCode: productOption?.productOptionCode ?? r.optionCode,
                    }
                }
                return { ...r }
            })
        })
    }

    const handleChangeTextValue = (e, lItem) => {
        const name = e.target.name;
        const value = e.target.value;

        setAddLoadItems(prev => {
            return prev?.map(r => {
                if (r.uuid === lItem?.uuid) {
                    return { ...r, [name]: value }
                }
                return { ...r }
            })
        })
    }

    const handleChangeNumberValue = (e, lItem) => {
        const name = e.target.name;
        const value = e.target.value;

        setAddLoadItems(prev => {
            return prev?.map(r => {
                if (r.uuid === lItem?.uuid) {
                    if (!value) {
                        return { ...r, [name]: '' }
                    }
                    return { ...r, [name]: Number(value) }
                }
                return { ...r }
            })
        })
    }

    const handleAddItem = () => {
        setAddLoadItems(prev => {
            return prev.concat({
                _id: null,
                uuid: uuidv4(),
                waybillNumber: '',
                productName: '',
                optionName: '',
                optionCode: '',
                boxWidth: 0,
                boxDepth: 0,
                boxHeight: 0,
                boxCBM: 0,
                boxQuantity: 0,
                estimatedProductQuantity: 0,
                originProductQuantity: 0,
                warehousingItemId: null,
                warehousingItemUUID: null,
                expectedPalletNumber: selectedPallet?.palletNumber,
                expectedPalletUUID: selectedPallet?.uuid,
                palletNumber: selectedPallet?.palletNumber,
                palletUUID: selectedPallet?.uuid,
                loadedYn: 'n',
                stageUUID: stageUUID,
                // workspaceId,
                // createdAt
            })
        })
    }

    const handleCopyItem = (loadItem) => {
        const copiedItem = {
            ...loadItem,
            uuid: uuidv4(),
        };

        setAddLoadItems(prev => prev.concat(copiedItem));
    };

    const handleRemoveItem = (loadItem) => {
        setAddLoadItems(prev => prev.filter(item => item.uuid !== loadItem.uuid));
    };

    const handleSubmit = async () => {

        const form = addLoadItems?.map(r => {
            return {
                ...r,
                productName: r.productName?.trim(),
                optionName: r.optionName?.trim(),
                optionCode: r.optionCode?.trim(),
                boxQuantity: Number(r.boxQuantity),
                estimatedProductQuantity: Math.round(Number(r.estimatedProductQuantity) * 100) / 100,
                waybillNumber: r.waybillNumber,
                boxWidth: Number(r.boxWidth),
                boxDepth: Number(r.boxDepth),
                boxHeight: Number(r.boxHeight),
                boxCBM: Math.round(((r.boxWidth * r.boxDepth * r.boxHeight) / 1000000000) * 1000000) / 1000000,
                palletUUID: selectedPallet?.uuid,
                palletNumber: selectedPallet?.palletNumber,
                loadedYn: r?.loadedYn,
                stageUUID: r?.stageUUID,
            }
        })
        onReqAddLoadItems(form)
    }

    return (
        <CustomDialog
            open={open}
            maxWidth='lg'
        >
            <St.AddLoadItemsModal.Header>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>상품 추가</CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={() => onClose()} />
                </CustomDialog.Header>
            </St.AddLoadItemsModal.Header>
            <St.AddLoadItemsModal.Body>
                <St.Table.Container>
                    <St.Table.Wrapper>
                        <St.Table.StyledTable>
                            <St.Table.ColumnGroup>
                                <col width={80} />
                                <col width={90} />
                                <col width={200} />
                                <col width={200} />
                                <col width={160} />
                                <col width={80} />
                                <col width={80} />
                                <col width={170} />
                                <col width={90} />
                                <col width={90} />
                                <col width={90} />
                                <col width={90} />
                            </St.Table.ColumnGroup>
                            <St.Table.TableHeader>
                                <St.Table.HeaderRow>
                                    <St.Table.HeaderCell>파레트번호</St.Table.HeaderCell>
                                    <St.Table.HeaderCell>빠른채움</St.Table.HeaderCell>
                                    <St.Table.HeaderCell>상품명</St.Table.HeaderCell>
                                    <St.Table.HeaderCell>옵션명</St.Table.HeaderCell>
                                    <St.Table.HeaderCell>옵션코드</St.Table.HeaderCell>
                                    <St.Table.HeaderCell>박스수량</St.Table.HeaderCell>
                                    <St.Table.HeaderCell>추정상품수량</St.Table.HeaderCell>
                                    <St.Table.HeaderCell>운송장번호</St.Table.HeaderCell>
                                    <St.Table.HeaderCell>박스너비(mm)</St.Table.HeaderCell>
                                    <St.Table.HeaderCell>박스깊이(mm)</St.Table.HeaderCell>
                                    <St.Table.HeaderCell>박스높이(mm)</St.Table.HeaderCell>
                                    <St.Table.HeaderCell>삭제</St.Table.HeaderCell>
                                </St.Table.HeaderRow>
                            </St.Table.TableHeader>
                            <St.Table.TableBody>
                                {addLoadItems?.map(loadItem => {
                                    return (
                                        <St.Table.TableRow
                                            key={loadItem?.uuid}
                                        >
                                            <St.Table.TableCell>
                                                <div className='flex gap-2 items-center'>
                                                    <div>
                                                        <CustomBlockButton
                                                            type='button'
                                                            className='copyButton'
                                                            onClick={() => handleCopyItem(loadItem)}
                                                        >
                                                            <CustomRatioImage.Figure className='icon'>
                                                                <CustomRatioImage.Image src='/assets/icons/moveDown_000000.svg' />
                                                            </CustomRatioImage.Figure>
                                                        </CustomBlockButton>
                                                    </div>
                                                    <div>
                                                        {loadItem?.palletNumber || ''}
                                                    </div>
                                                </div>
                                            </St.Table.TableCell>
                                            <St.Table.TableCell>
                                                <CustomBlockButton
                                                    type='button'
                                                    className='quickFillButton'
                                                    onClick={() => handleOpenQuickFill(loadItem)}
                                                >
                                                    빠른채움
                                                </CustomBlockButton>
                                            </St.Table.TableCell>
                                            <St.Table.TableCell>
                                                <input
                                                    type='text'
                                                    className='cellInput'
                                                    name='productName'
                                                    value={loadItem?.productName || ''}
                                                    onChange={(e) => handleChangeTextValue(e, loadItem)}
                                                ></input>

                                            </St.Table.TableCell>
                                            <St.Table.TableCell>
                                                <input
                                                    type='text'
                                                    className='cellInput'
                                                    name='optionName'
                                                    value={loadItem?.optionName || ''}
                                                    onChange={(e) => handleChangeTextValue(e, loadItem)}
                                                ></input>

                                            </St.Table.TableCell>
                                            <St.Table.TableCell>
                                                <input
                                                    type='text'
                                                    className='cellInput'
                                                    name='optionCode'
                                                    value={loadItem?.optionCode || ''}
                                                    onChange={(e) => handleChangeTextValue(e, loadItem)}
                                                ></input>

                                            </St.Table.TableCell>
                                            <St.Table.TableCell>
                                                <CustomBlockButton
                                                    type='button'
                                                    className='quantityCell'
                                                    onClick={() => handleOpenQuantityKeypad(loadItem?.uuid, 'boxQuantity', '박스수량', loadItem?.boxQuantity)}
                                                >
                                                    {loadItem?.boxQuantity ?? 0}
                                                </CustomBlockButton>
                                            </St.Table.TableCell>
                                            <St.Table.TableCell>
                                                <CustomBlockButton
                                                    type='button'
                                                    className='quantityCell'
                                                    onClick={() => handleOpenQuantityKeypad(loadItem?.uuid, 'estimatedProductQuantity', '추정상품수량', loadItem?.estimatedProductQuantity)}
                                                >
                                                    {loadItem?.estimatedProductQuantity ?? 0}
                                                </CustomBlockButton>
                                            </St.Table.TableCell>
                                            <St.Table.TableCell>
                                                <textarea
                                                    type='text'
                                                    className='cellTextarea'
                                                    name='waybillNumber'
                                                    value={loadItem?.waybillNumber || ''}
                                                    onChange={(e) => handleChangeTextValue(e, loadItem)}
                                                ></textarea>

                                            </St.Table.TableCell>
                                            <St.Table.TableCell>
                                                <input
                                                    type='number'
                                                    className='cellInput'
                                                    name='boxWidth'
                                                    value={loadItem?.boxWidth ?? ''}
                                                    onChange={(e) => handleChangeNumberValue(e, loadItem)}
                                                ></input>

                                            </St.Table.TableCell>
                                            <St.Table.TableCell>
                                                <input
                                                    type='number'
                                                    className='cellInput'
                                                    name='boxDepth'
                                                    value={loadItem?.boxDepth ?? ''}
                                                    onChange={(e) => handleChangeNumberValue(e, loadItem)}
                                                ></input>

                                            </St.Table.TableCell>
                                            <St.Table.TableCell>
                                                <input
                                                    type='number'
                                                    className='cellInput'
                                                    name='boxHeight'
                                                    value={loadItem?.boxHeight ?? ''}
                                                    onChange={(e) => handleChangeNumberValue(e, loadItem)}
                                                ></input>
                                            </St.Table.TableCell>
                                            <St.Table.TableCell>
                                                <CustomBlockButton
                                                    type='button'
                                                    className='removeButton'
                                                    onClick={() => handleRemoveItem(loadItem)}
                                                >
                                                    <CustomRatioImage.Figure className='icon'>
                                                        <CustomRatioImage.Image src='/assets/icons/close_default_red1.svg' />
                                                    </CustomRatioImage.Figure>
                                                </CustomBlockButton>
                                            </St.Table.TableCell>
                                        </St.Table.TableRow>
                                    );
                                })}
                                <St.Table.TableRow className='addItemRow'>
                                    <St.Table.TableCell colSpan={12}>
                                        <CustomBlockButton
                                            type='button'
                                            className='addCellButton'
                                            onClick={() => handleAddItem()}
                                        >
                                            추가
                                        </CustomBlockButton>
                                    </St.Table.TableCell>
                                </St.Table.TableRow>
                            </St.Table.TableBody>
                        </St.Table.StyledTable>
                    </St.Table.Wrapper>
                </St.Table.Container>
                <div className='buttons'>
                    <CustomBlockButton
                        type='button'
                        onClick={() => onClose()}
                    >
                        취소
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        className='confirm'
                        onClick={() => handleSubmit()}
                    >
                        추가
                    </CustomBlockButton>
                </div>
            </St.AddLoadItemsModal.Body>

            <ProductOptionPickerModal
                open={!!quickFillTargetLoadItem}
                onClose={handleCloseQuickFill}
                onSelect={handleSelectProductOption}
            />

            <CustomQuantityKeypadModal
                open={!!quantityKeypad}
                label={quantityKeypad?.label}
                initialValue={quantityKeypad?.value}
                onClose={handleCloseQuantityKeypad}
                onConfirm={handleConfirmQuantity}
            />
        </CustomDialog>
    );
}

function EditChildRackLocationAddressesModal({
    open,
    onClose,
    editTargetPallet,
    pallets,
    onReqUpdatePallets,
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [enabledLocationAddresses, setEnabledLocationAddresses] = useState(null);

    useEffect(() => {
        handleFetchRackLocationAddresses();
    }, []);

    const handleFetchRackLocationAddresses = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const enabledLocationsFetchResult = await axios.get(`${API_HOST}/rack-locations`, {
            headers: headers,
            params: {
                type: 'INVENTORY',
                enabledYn: 'y'
            }
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        let enabledLocations;
        if (enabledLocationsFetchResult?.content) {
            enabledLocations = enabledLocationsFetchResult?.content;
            enabledLocations.sort((a, b) => {
                const aSplit = a?.address?.split('-');
                const bSplit = b?.address?.split('-');
                if (`${aSplit[3]}_${aSplit[1]}_${aSplit[2]}_${aSplit[4]}` < `${bSplit[3]}_${bSplit[1]}_${bSplit[2]}_${bSplit[4]}`) return -1;
                if (`${aSplit[3]}_${aSplit[1]}_${aSplit[2]}_${aSplit[4]}` > `${bSplit[3]}_${bSplit[1]}_${bSplit[2]}_${bSplit[4]}`) return 1;
                return 0;
            })
        }

        const aleadyMappedAddressSet = new Set();

        pallets?.forEach(pallet => {
            if (!pallet?.rackLocationAddress) {

            } else if (!aleadyMappedAddressSet.has(pallet?.rackLocationAddress)) {
                aleadyMappedAddressSet.add(pallet?.rackLocationAddress);
            }

            pallet?.childRackLocationAddresses?.forEach(childRackLocationAddress => {
                if (!childRackLocationAddress) {
                    return;
                }

                if (!aleadyMappedAddressSet.has(childRackLocationAddress)) {
                    aleadyMappedAddressSet.add(childRackLocationAddress);
                }
            });
        })

        enabledLocations = enabledLocations?.filter(r => !aleadyMappedAddressSet?.has(r?.address))

        setEnabledLocationAddresses(enabledLocations?.map(r => r.address));
        CustomBackdropController().hideBackdrop();
    }

    const handleSelect = (address) => {
        const newEditTargetPallet = {
            ...editTargetPallet
        }

        if (!address) {
            newEditTargetPallet.childRackLocationAddresses = [];
        } else {
            newEditTargetPallet.childRackLocationAddresses = newEditTargetPallet.childRackLocationAddresses.concat(address);
        }

        onReqUpdatePallets([{
            ...newEditTargetPallet
        }]);
    };

    return (
        <CustomDialog
            open={open}
            onClose={() => onClose()}
        >
            <St.EditChildRackLocationAddressesModal.BodyContainer>
                <CustomBlockButton
                    type='button'
                    onClick={() => handleSelect('')}
                >
                    지정안함
                </CustomBlockButton>
                {enabledLocationAddresses?.map(enabledLocationAddress => {
                    return (
                        <CustomBlockButton
                            type='button'
                            key={enabledLocationAddress}
                            onClick={() => handleSelect(enabledLocationAddress)}
                        >
                            {enabledLocationAddress}
                        </CustomBlockButton>
                    );
                })}
            </St.EditChildRackLocationAddressesModal.BodyContainer>
        </CustomDialog>
    );
}

function ReflectLocationModal({
    open,
    onClose,
    onReqRegisterLocation
}) {
    const [key, setKey] = useState('');

    const handleChangeKey = (e) => {
        const value = e.target.value;
        setKey(value);
    }
    const handleConfirm = () => {
        if (key !== 'synabro') {
            customToast.error('키가 일치하지 않습니다.');
            return;
        }
        onReqRegisterLocation();
    }

    return (
        <CustomDialog open={open} onClose={() => onClose()}>
            <St.ReflectLocationModal.Header>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>로케이션 반영</CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={() => onClose()} />
                </CustomDialog.Header>
            </St.ReflectLocationModal.Header>
            <St.ReflectLocationModal.Body>
                <div className='notice'>로케이션을 반영하시겠습니까?</div>
                <CustomLabelInput className='mt-3'>
                    <CustomLabelInput.Input
                        type='password'
                        value={key}
                        onChange={(e) => handleChangeKey(e)}
                    />
                    <CustomLabelInput.Label>로케이션 반영 키</CustomLabelInput.Label>
                </CustomLabelInput>
                <div className='buttons'>
                    <CustomBlockButton
                        type='button'
                        onClick={() => onClose()}
                    >
                        취소
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        className='confirm'
                        onClick={() => handleConfirm()}
                    >
                        반영
                    </CustomBlockButton>
                </div>
            </St.ReflectLocationModal.Body>
        </CustomDialog>
    );
}

function ChangeStatusModal({
    open,
    onClose,
    editTargetPallet,
    onReqUpdatePallets
}) {

    const handleSelect = (status) => {
        onReqUpdatePallets([{
            ...editTargetPallet,
            status: status
        }]);
    }

    return (
        <CustomDialog open={open} onClose={() => onClose()}>
            <St.ChangeStatusModal.Header>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>상태 변경</CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={() => onClose()} />
                </CustomDialog.Header>
            </St.ChangeStatusModal.Header>
            <St.ChangeStatusModal.Body>
                <div className='buttons'>
                    <CustomBlockButton
                        type='button'
                        className='loading'
                        onClick={() => handleSelect('LOADING')}
                    >
                        적재중
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        className='prepared'
                        onClick={() => handleSelect('PREPARED')}
                    >
                        적재완료
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        className='done'
                        onClick={() => handleSelect('DONE')}
                    >
                        입고완료
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        className='holding'
                        onClick={() => handleSelect('HOLDING')}
                    >
                        보류
                    </CustomBlockButton>
                </div>
            </St.ChangeStatusModal.Body>
        </CustomDialog>
    );
}

function AutoMappingLocationModal({
    open,
    onClose,
    currentStageUUID,
    onAutoMappingLocation
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [viewMode, setViewMode] = useState('DEFAULT'); // DEFAULT, STAGE_SELECTION
    const [stages, setStages] = useState(null);
    const [selectedStages, setSelectedStages] = useState([]);

    useEffect(() => {
        if (viewMode === 'STAGE_SELECTION' && !stages) {
            handleReqFetchStages();
        }

    }, [viewMode]);

    const handleReqFetchStages = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const stagesFetchResult = await axios.get(`${API_HOST}/inbound-stages`, {
            headers: headers
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (stagesFetchResult?.content) {
            setStages(stagesFetchResult?.content);
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleChangeViewMode = (mode) => {
        setViewMode(mode);
    }

    const handleSelectStage = (selectedStage) => {
        setSelectedStages(prev => {
            if (prev.includes(selectedStage)) {
                return prev.filter(r => r !== selectedStage)
            }
            return prev.concat(selectedStage)
        })
        if (viewMode === 'STAGE_SELECTION') {
            handleChangeViewMode('DEFAULT');
        }
    }

    const handleConfirm = () => {
        onAutoMappingLocation(selectedStages);
    }
    return (
        <CustomDialog open={open} onClose={() => onClose()}>
            <St.AutoMappingLocationModal.Header>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>로케이션 자동매핑</CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={() => onClose()} />
                </CustomDialog.Header>
            </St.AutoMappingLocationModal.Header>
            {viewMode === 'DEFAULT' &&
                <St.AutoMappingLocationModal.Body>
                    <div className='stageSelection'>
                        <div className='label'>중복방지 스테이지 선택</div>
                        <div className='stageList'>
                            <CustomBlockButton
                                type='button'
                                onClick={() => handleChangeViewMode('STAGE_SELECTION')}
                            >
                                추가
                            </CustomBlockButton>
                            {selectedStages?.map(stage => {
                                return (
                                    <div className='stageItem' key={stage?.uuid}>
                                        <div>({stage?.name})</div>
                                        <div>{stage?.uuid}</div>
                                        <div className='blanket' onClick={() => handleSelectStage(stage)}>
                                            <div className='icon'>
                                                <CustomRatioImage.Figure>
                                                    <CustomRatioImage.Image src='/assets/icons/delete_000000.svg' />
                                                </CustomRatioImage.Figure>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        {selectedStages?.length > 0 &&
                            <div className='notice'>위 스테이지들에 매핑된 로케이션은 제외하고 자동 매핑됩니다.</div>
                        }
                    </div>
                    <CustomBlockButton
                        type='button'
                        className='confirmButton'
                        onClick={() => handleConfirm()}
                    >
                        자동매핑 실행
                    </CustomBlockButton>
                </St.AutoMappingLocationModal.Body>
            }

            {viewMode === 'STAGE_SELECTION' &&
                <St.AutoMappingLocationModal.Body>
                    <div className='header'>
                        <CustomBlockButton
                            type='button'
                            onClick={() => handleChangeViewMode('DEFAULT')}
                        >
                            뒤로
                        </CustomBlockButton>
                    </div>
                    <div className='stageSelection'>
                        <div className='stageList'>
                            {stages?.filter(r => {
                                if (selectedStages?.find(stage => stage.uuid === r.uuid) || currentStageUUID === r.uuid) {
                                    return false;
                                }
                                return true;
                            })?.map(stage => {
                                return (
                                    <div
                                        key={stage?.uuid}
                                        className='stageItem'
                                    >
                                        <div className='name'>{stage?.name}</div>
                                        <div className='uuid'>{stage?.uuid}</div>
                                        <div className='blanket' onClick={() => handleSelectStage(stage)}>
                                            <div className='icon'>
                                                <CustomRatioImage.Figure>
                                                    <CustomRatioImage.Image src='/assets/icons/add_default_000000.svg' />
                                                </CustomRatioImage.Figure>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </St.AutoMappingLocationModal.Body>
            }

        </CustomDialog >
    );
}